/** WPS / spool welding pass names (Hot, Root, Fill, …). */
export const WELDING_PASS_NAME_OPTIONS = [
  { value: 'Hot', label: 'Hot' },
  { value: 'Root', label: 'Root' },
  { value: 'Fill', label: 'Fill' },
  { value: 'Last Fill', label: 'Last Fill' },
  { value: 'Strip', label: 'Strip' },
  { value: 'Cap', label: 'Cap' },
  { value: 'Disabled', label: 'Disabled' },
] as const;

export type WeldingPassNameValue = (typeof WELDING_PASS_NAME_OPTIONS)[number]['value'];

export function nextAvailableWeldingPassName(usedNames: string[]): string {
  const next = WELDING_PASS_NAME_OPTIONS.find((o) => !usedNames.includes(o.value));
  return next?.value ?? WELDING_PASS_NAME_OPTIONS[WELDING_PASS_NAME_OPTIONS.length - 1].value;
}

/** e.g. "Fill 2" → "Fill"; "Root" → "Root". */
export function weldingPassNameBase(label: string): string {
  const trimmed = label.trim();
  const match = trimmed.match(/^(.+?)\s+(\d+)$/);
  return match ? match[1].trim() : trimmed;
}

/** One row uses the base name; multiple rows use "Fill 1", "Fill 2", … */
export function buildWeldingPassRowLabels(baseName: string, numberOfPasses: number): string[] {
  const base = baseName.trim();
  const count = Math.min(20, Math.max(1, Math.floor(numberOfPasses) || 1));
  if (count === 1) return [base];
  return Array.from({ length: count }, (_, i) => `${base} ${i + 1}`);
}
